import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { MessagePlugin } from 'tdesign-react';

import { PLAY_INFO_ID } from '@/const/mission';
import { IBot, IMission, IScene, SceneType } from '@/interface';
import { CgiErrorCode } from '@/services/cgi';
import { fetchSceneDetail, getStoryFullSceneList } from '@/services/scene';
import { fetchStoryDetail } from '@/services/story';

export interface SceneState {
  sceneInfo: IScene;
  scenes: IScene[];
  fullSceneList: IScene[]; // 所有章节的全量scene
  currSceneId: string;
  currSceneIndex: number;
  loading: boolean;
  missionList: IMission[];
  bots: IBot[];
  playBots: Partial<IBot>[];
  sort: boolean;
  missionSort: boolean;
  commonBots: Partial<IBot>[];
}

export const NEW_SCENE = 'new';

export const initialState: SceneState = {
  loading: false,
  sceneInfo: {
    chapterId: '',
    sceneId: '',
    sceneType: SceneType.SCENE_TYPE_DEFAULT,
    name: '',
    missions: [],
    botPromptList: [],
    guideReply: false,
    bgm: {
      url: {
        url: '',
        localPath: '',
        name: '',
      },
      autoPlay: false,
      loopPlay: true,
    },
  },
  missionList: [],
  scenes: [],
  fullSceneList: [],
  bots: [],
  currSceneId: '',
  currSceneIndex: 0,
  playBots: [],
  sort: false,
  missionSort: false,
  commonBots: [],
};

export const getStorySceneList = createAsyncThunk('scene/getStorySceneList', fetchStoryDetail);

export const getFullSceneList = createAsyncThunk('scene/fullList', getStoryFullSceneList);

export const getSceneDetail = createAsyncThunk('scene/detail', fetchSceneDetail);

export const scene = createSlice({
  name: 'scene',
  initialState,
  reducers: {
    initSceneInfo(state) {
      return {
        ...state,
        sceneInfo: initialState.sceneInfo,
      };
    },
    initSceneState() {
      return { ...initialState };
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    updateSceneInfo: (state, { payload }) => {
      state.sceneInfo = { ...payload };
    },
    addMissionList: (state, { payload }) => {
      state.missionList.push(payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStorySceneList.fulfilled, (state, { payload }) => {
      if (payload?.code === CgiErrorCode.NO_ERROR) {
        return {
          ...state,
          scenes: payload?.scenes || [],
          playBots: [{
            id: PLAY_INFO_ID,
            name: payload?.storyInfo?.playerInfo?.name,
          }],
          loading: false,
        };
      }
      MessagePlugin.error(payload.message);
    });
    builder.addCase(getSceneDetail.fulfilled, (state, { payload }) => {
      if (payload?.code === CgiErrorCode.NO_ERROR) {
        const bot = payload?.data?.botPromptList?.map((e: any) => e?.botDetail) || [];
        return {
          ...state,
          sceneInfo: { ...state.sceneInfo, ...payload.data },
          missionList: payload?.data?.missionList?.map((e: any) => ({
            ...e?.mission,
          })) || [],
          bots: bot,
          loading: false,
        };
      }
      MessagePlugin.error(payload.message || payload.msg || '幕信息拉取失败，请稍后重试');
    });
    builder.addCase(getFullSceneList.fulfilled, (state, { payload }) => {
      if (payload?.code === CgiErrorCode.NO_ERROR) {
        return {
          ...state,
          fullSceneList: payload?.list || [],
        };
      }
      MessagePlugin.error(payload?.message || '获取幕列表失败，请稍后重试');
    });
  },
});

export const {
  initSceneInfo,
  updateSceneInfo,
  setLoading,
  initSceneState,
  addMissionList,
} = scene.actions;

export default scene.reducer;
